const ActivityFeed = (app) => {
  app.get("/activity-feed", async ({ req, res, api, load, locals }) => {
    const coachId = locals.activeUser._id;
    const query = {
      limit: 2,
      sort: { order: -1 },
      coachId,
    };
    await load("activityFeed", { query });

    return res.backDontScroll();
  });
};
export default ActivityFeed;
